import ChevronRight from "@mui/icons-material/ChevronRight";
import LightbulbOutlined from "@mui/icons-material/LightbulbOutlined";
import { Box, Typography } from "@mui/material";
import { AnnouncementModal } from "components/ProductAnnouncement/AnnouncementModal";
import ScoutIcon from "components/ScoutIcon";

import { encampBrandColors } from "../../../../colors";
import { SCOUT_LAUNCH_MODAL_COPY } from "./scoutLaunchAnnouncementConfig";

type ScoutLaunchAnnouncementModalProps = {
  open: boolean;
  onDismiss: () => void;
  onSoftDismiss: () => void;
  dontShowAgain: boolean;
  onDontShowAgainChange: (checked: boolean) => void;
  onLearnMore: () => void;
  onStartTour: () => void;
};

export function ScoutLaunchAnnouncementModal({
  open,
  onDismiss,
  onSoftDismiss,
  dontShowAgain,
  onDontShowAgainChange,
  onLearnMore,
  onStartTour,
}: ScoutLaunchAnnouncementModalProps) {
  return (
    <AnnouncementModal
      open={open}
      onDismiss={onDismiss}
      onSoftDismiss={onSoftDismiss}
      dontShowAgainLabel="Don't show me this again"
      dontShowAgain={dontShowAgain}
      onDontShowAgainChange={onDontShowAgainChange}
      titleId="scout-launch-announcement-title"
      dismissAriaLabel="Dismiss Scout launch announcement"
      hero={
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: "50%",
            bgcolor: encampBrandColors.pumpkin,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ScoutIcon sx={{ fontSize: 42, color: "common.white" }} />
        </Box>
      }
      title={SCOUT_LAUNCH_MODAL_COPY.headline}
      subtitle={SCOUT_LAUNCH_MODAL_COPY.subheadline}
      secondaryCtaLabel={SCOUT_LAUNCH_MODAL_COPY.learnMoreLabel}
      secondaryCtaIcon={<LightbulbOutlined />}
      onSecondaryCta={onLearnMore}
      primaryCtaLabel={SCOUT_LAUNCH_MODAL_COPY.startTourLabel}
      primaryCtaIcon={<ChevronRight />}
      onPrimaryCta={onStartTour}
    >
      <Typography variant="body1" color="text.primary">
        Scout is grounded in the <strong>Code of Federal Regulations</strong> and{" "}
        <strong>Encamp&apos;s compliance knowledge base</strong> and can answer the regulatory
        questions you run into every day.
      </Typography>
    </AnnouncementModal>
  );
}
